module.exports = __webpack_public_path__ + "img/f.93059e90.jpg";